export default "__VITE_ASSET__CIZcInjt__"